import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { useAppBackgroundLazyQuery } from "../graphql/generated/schema-types";

export function useAppBackgroundQueries(enabled: boolean): void {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const [execute] = useAppBackgroundLazyQuery({
    notifyOnNetworkStatusChange: true,
  });
  useEffect(() => {
    if (enabled && isAuthenticated && inProgress === InteractionStatus.None) {
      execute();
    }
  }, [enabled, execute, isAuthenticated, inProgress]);
}
